import { useSelector } from "react-redux";
import { FilterType, Status } from "@shared/types";
import { BOT_TYPE_TO_FILTERS_SLICE } from "@shared/features/bots/constants";
import { BotType } from "@shared/types";
import { useMemo } from "react";
import useQuery from "utils/hooks/useQuery";
import { FILTER_TYPES_DATA } from "@shared/features/filters/constants";
import { sharedLib } from "@shared/services/shared.service";
import { ARCHIVED_BOTS_FEATURE_FLAG } from "@shared/common/constants";

export const useIncludeArchived = (botType: BotType) => {
  const filtersSlice = BOT_TYPE_TO_FILTERS_SLICE[botType];
  const filtersState = useSelector(filtersSlice.selectors.selectFilters);
  const { loadedFilters, filters } = filtersState;
  const query = useQuery();

  const user = useSelector(sharedLib.selectors.authentication.selectUser);
  const archivedBotsEnabled = user?.hasFeatureFlag(ARCHIVED_BOTS_FEATURE_FLAG);

  const urlArchivedBotsEnabled = useMemo(() => {
    if (loadedFilters) {
      const statusFilterValue = filters[FilterType.STATUS]?.value as
        | string[]
        | undefined;
      return statusFilterValue?.includes(Status.ARCHIVED);
    }

    const statusQueryKey = FILTER_TYPES_DATA[FilterType.STATUS].queryKey;
    const statusQuery = query.get(statusQueryKey);
    if (statusQuery) {
      try {
        const parsedStatus = JSON.parse(statusQuery);
        if (Array.isArray(parsedStatus)) {
          return parsedStatus.includes(Status.ARCHIVED);
        }
      } catch {}
    }

    return false;
  }, [loadedFilters, filters, query]);

  return !!urlArchivedBotsEnabled && !!archivedBotsEnabled;
};
